import React from 'react';
import {
  makeStyles,
  Theme,
  Grid,
  Dialog,
  DialogContent,
} from '@material-ui/core';
import { LottieAnimation, H4Text, HeadlineText, colors } from 'design-system';

// Animation file
import loadingAnimation from '../../../../lottieFiles/inspectionLoadingAnimation.json';

const useStyles = makeStyles((theme: Theme) => ({
  containerGrid: {
    marginTop: theme.spacing(3),
  },
  appBar: {
    ...theme.mixins.toolbar,
    backgroundColor: colors.madison,
  },
  captionText: {
    maxWidth: 250,
    fontWeight: 'normal',
    lineHeight: '21px',
  },
  titleText: {
    maxWidth: 270,
  },
  contentDialog: {
    background: 'linear-gradient(0.16deg, #FFFFFF 13.23%, #CEE8FF 105.34%)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
  },
}));

/** This is a special dialogue component, since it cannot be closed by the user. */
type Props = {
  open: boolean;
  comment: string;
  mainText: React.ReactNode;
  caption: React.ReactNode;
};

const NetworkProgressDialogue = ({
  open,
  mainText,
  comment,
  caption,
}: Props): JSX.Element => {
  const classes = useStyles();
  return (
    <Dialog open={open} fullScreen>
      <DialogContent className={classes.contentDialog}>
        <Grid container spacing={3} className={classes.containerGrid}>
          <Grid item xs={12} container justifyContent="center">
            <HeadlineText
              data-testid="title"
              align="center"
              className={classes.titleText}
            >
              {mainText}
            </HeadlineText>
          </Grid>
          <Grid item xs={12} container justifyContent="center">
            <LottieAnimation
              data-testid="lottie-animation"
              animationJson={loadingAnimation}
            />
          </Grid>
          <Grid item xs={12} container justifyContent="center">
            <H4Text
              data-testid="caption"
              align="center"
              className={classes.captionText}
            >
              <strong>{caption}</strong>
              <br />
              {comment}
            </H4Text>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default NetworkProgressDialogue;
